import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectHeroImage from "../ProjectHeroImage";
import Image from "../../../../img/dumpty.png";
import Links from "../../../Links";

const Section = styled(ProjectSection)`
  background: #6637b6;
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto auto auto auto;
  }
`;

const LocalProjectDescription = styled.p`
  margin-bottom: var(--spacing-medium);
  font-size: var(--font-size-text-small);

  @media (min-width: 768px) {
    padding: var(--spacing-clear) var(--spacing-medium);
  }
`;

function Dumpty() {
  return (
    <Section>
      <ProjectTitle title="Dumpty" tag="2026" tagLink="https://dumpty.redactd.xyz" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="Xcode">
          <Icons type="xcode-small" />
        </Badge>
        <Badge small title="Agents & AI">
          <Icons type="ai-small" />
        </Badge>
      </ProjectSectionSkills>

      <LocalProjectDescription>
        Dumpty is a native macOS menu bar application designed to store, search, and copy snippets with a
        single click. Built as a desktop utility, it eliminates the friction of managing reusable code, prompts, and
        templates in daily workflows.
      </LocalProjectDescription>

      <ButtonGroup>
        <Button href="https://dumpty.redactd.xyz/" color="white" target="_blank" rel="noopener noreferrer">
          View App
        </Button>
        <Button href="/case-studies#dumpty" color="white">
          Read Blog
        </Button>
      </ButtonGroup>

      <ProjectHeroImage src={Image} desktop />
    </Section>
  );
}

export default Dumpty;
